import request from '@/utils/request'

//登录
export const login = (parameter)=> request.post('/application/login',parameter)
//注销
export const logout = (parameter)=> request.post('/application/logout',parameter)
